import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const SettlementWaterfallChart = ({ data }) => {
  const formatCurrency = (value) => {
    return `Rp ${(value / 1000000)?.toFixed(1)}M`;
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-elevation-3">
          <p className="text-sm font-semibold text-popover-foreground mb-1">{payload?.[0]?.payload?.name}</p>
          <p className="text-sm text-muted-foreground">
            Jumlah: <span className="font-semibold text-foreground data-text">Rp {payload?.[0]?.value?.toLocaleString('id-ID')}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6 shadow-elevation-1">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg md:text-xl font-semibold text-foreground">Aliran Settlement Harian</h2>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded bg-primary"></div>
            <span className="text-xs md:text-sm text-muted-foreground">Positif</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded bg-error"></div>
            <span className="text-xs md:text-sm text-muted-foreground">Negatif</span>
          </div>
        </div>
      </div>
      <div className="w-full h-80 md:h-96" aria-label="Settlement Waterfall Chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              tickFormatter={formatCurrency}
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Bar dataKey="value" radius={[8, 8, 0, 0]}>
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.value >= 0 ? 'var(--color-primary)' : 'var(--color-error)'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SettlementWaterfallChart;